export default __webpack_public_path__ + "media/zurb/img/events/wired/rcs/rcs-4-e84c4568e958e6a31c82e9dcc809ba57.jpg";